export const ROUTE_SHIPMENT_SEARCH = 'shipment-search';
export const ROUTE_EDIT_SHIPMENT = 'edit-shipment';
export const ROUTE_SHIPMENT_DETAILS = 'shipment-details';
export const ROUTE_SHIPMENT_QUOTES = 'shipment-quotes';

